import {internalApi} from "../../../common/axios";
import {useQueryBase} from "../../../shared/hooks/useHookBase";

export const SEGMENT_EVENTS_KEY = 'segmentEvents';

const fetchEventSegments = async () => {
    const {data} = await internalApi.get('events/segment/condition');
    return data.rows;
}

const fetchSegmentEvents = async () => {
    const {data} = await internalApi.get('events/segment');
    return data.rows;
}

export const useEventSegments = () => useQueryBase('eventSegment', fetchEventSegments, {staleTime: 0});
export const useSegmentEvents = () => useQueryBase(SEGMENT_EVENTS_KEY, fetchSegmentEvents, {staleTime: 0});
